<template>
  <div class="login" v-bind:class="{ 'isDesktop': $isDesktop, 'isMobile': $isMobile }">
    <!-- <PopupHeader :radiousActive="$isDesktop" :postLoginDialogActive="false" :theme="headerTheme" :title="title"
      :menuActive="false" :logoActive="false" @clicked='loginClose' :removeCloseIcon=true /> -->
    <div class="login-background"></div>
    <div class='info-text' v-bind:class="{ 'isDesktop': $isDesktop }">
      <div class="info-text-detail-paragraph" v-bind:class="{ 'isDesktop': $isDesktop }">
        <div class="form-container" v-bind:class="{ 'isDesktop': $isDesktop }">
          <form v-on:submit.prevent="submit($event)" autocomplete="off">
          <div class="info-text-detail-header">
            <Description :title="$t('texts.userLogin')" />
            <div>{{ $t('texts.loginMethod') }}</div>
            <!-- <Description :title="$t('texts.userLogin')" /> -->
          </div>
          <!-- <tabs :on-tab-click="tabCallback">
            <tab-item :label="$t('texts.loginWithIdentity')" :disabled="checkPhoneStatus">
              <div class="form-control-elements" v-if="activeTabIndex === 0">
                <div class='form-control'>
                  <label class='label'>{{ $t("texts.identity") }}</label>
                  <input autocomplete="off" class='input'
                    :class="{ 'input': true, 'is-danger': errors.has($t('texts.identity')) }" v-model='customer.tckn'
                    v-mask="'###########'" type="tel" minlength="11" :masked=false :name="$t('texts.identity')"
                    :disabled="checkPhoneStatus" v-validate="'required|min:11|max:11|checkTcNum'" />
                  <span class="help is-danger">{{ errors.first($t('texts.identity')) }}</span>
                </div>
              </div>
            </tab-item>
            <tab-item :label="$t('texts.loginWithTax')" :disabled="checkPhoneStatus">
              <div class="form-control-elements" v-if="activeTabIndex === 1">
                <div class='form-control'>
                  <label class='label'>{{ $t("texts.vkn") }}</label>
                  <input autocomplete="off" class='input'
                    :class="{ 'input': true, 'is-danger': errors.has($t('texts.vkn')) }" v-model='customer.vkn'
                    v-mask="'##########'" type="tel" minlength="9" :masked=false :name="$t('texts.vkn')"
                    :disabled="checkPhoneStatus" v-validate="'required|min:9|max:10'" key="login-taxId" />
                  <span class="help is-danger">{{ errors.first($t('texts.vkn')) }}</span>
                </div>
              </div>
            </tab-item>
          </tabs> -->

          <div class="control has-addons login-selection" v-bind:class="{'radio-row mobile': $isMobile}">
            <label class="radio blu-radio radio is-primary" v-bind:class="{'on': activeTabIndex === '0' }">
              <input type="radio" name="activeTabIndex" value="0" v-model='activeTabIndex' >
              <span>{{ $t('texts.loginWithIdentity') }}</span>
            </label>
            <label class="radio blu-radio radio is-primary" v-bind:class="{'on': activeTabIndex === '1' }">
              <input type="radio" name="activeTabIndex" value="1" v-model='activeTabIndex'>
              <span>{{ $t('texts.loginWithTax') }}</span>
            </label>
            <label class="radio blu-radio radio is-primary" v-bind:class="{'on': activeTabIndex === '2' }">
              <input type="radio" name="activeTabIndex" value="2" v-model='activeTabIndex'>
              <span>{{ $t('texts.loginWithAgency') }}</span>
            </label>
          </div>

          <div class="form-control-elements" v-if="activeTabIndex === '0' || activeTabIndex === '2'">
            <div class='form-control'>
              <label v-if="activeTabIndex === '0'" class='label'>{{ $t("texts.identity") }}</label>
              <label v-if="activeTabIndex === '2'" class='label'>{{ $t("texts.agencyIdentity") }}</label>
              <input autocomplete="off" class='input'
                :class="{ 'input': true, 'is-danger': errors.has($t('texts.identity')) }" v-model='customer.tckn'
                v-mask="'###########'" type="tel" minlength="11" :masked=false :name="$t('texts.identity')"
                :disabled="checkPhoneStatus" v-validate="'required|min:11|max:11|checkTcNum'" />
              <span class="help is-danger">{{ errors.first($t('texts.identity')) }}</span>
            </div>
          </div>

          <div class="form-control-elements" v-if="activeTabIndex === '1'">
            <div class='form-control'>
              <label class='label'>{{ $t("texts.vkn") }}</label>
              <input autocomplete="off" class='input'
                :class="{ 'input': true, 'is-danger': errors.has($t('texts.vkn')) }" v-model='customer.vkn'
                v-mask="'##########'" type="tel" minlength="9" :masked=false :name="$t('texts.vkn')"
                :disabled="checkPhoneStatus" v-validate="'required|min:9|max:10'" key="login-taxId" />
              <span class="help is-danger">{{ errors.first($t('texts.vkn')) }}</span>
            </div>
          </div>
          <!--           <div class="form-control-elements">
            <div class='form-control'>
              <label class='label'>{{ $t("texts.identity") }}</label>
              <input autocomplete="off" class='input' :class="{'input': true, 'is-danger': errors.has($t('texts.identity')) }" v-model='customer.tckn' v-mask="'###########'" type="tel" minlength="11" :masked=false :name="$t('texts.identity')" :disabled="checkPhoneStatus" v-validate="'required|min:11|max:11|checkTcNum'"/>
              <span class="help is-danger">{{ errors.first($t('texts.identity')) }}</span>
            </div>
          </div> -->
          <div class="form-control-elements verification-elements">
            <div class='form-control' v-if="!checkPhoneStatus">
              <label class='label'>{{ $t("texts.mobilePhone") }} <span v-if="hasPhoneNumber"> (Son iki hanesi: {{
                customer.maskedPhone }})</span></label>
              <input autocomplete="off" class='input'
                :class="{ 'input': true, 'is-danger': errors.has($t('texts.mobilePhone')) }" ref="mobilePhone"
                v-model='customer.phone' v-mask="'### ### ## ##'" type="tel" :placeholder='placeholder' :masked=true
                v-validate="'min:13|max:13'" :disabled="!openPhoneArea" :required="!openPhoneArea && !checkPhoneStatus"
                :name="$t('texts.mobilePhone')" key="mobilePhone" />
              <span class="help is-danger">{{ errors.first($t('texts.mobilePhone')) }}</span>
            </div>
            <div class='form-control' v-else>
              <label class='label'>{{ $t('texts.smsSecurityCode') }}</label>
              <div class="field has-addons">
                <p class="control">
                  <input autocomplete="one-time-code" class="input" type="password" maxlength="6"
                    :class="{ 'input': true, 'is-danger': errors.has($t('texts.smsCode')) }" v-model='customer.code'
                    v-mask="'######'" placeholder="* * * * * *" :name="$t('texts.smsCode')" v-validate="'min:6|max:6'"
                    :required="checkPhoneStatus && remainingtime > 0" :disabled="remainingtime == 0" key="smsCode">
                </p>
                <p class="control">
                  <a class="button is-static" v-on:click.stop="sendSmsCode($event)"
                    v-bind:class="{ 'disabled': remainingtime != 0, 'last10': (remainingtime > 0 && remainingtime <= 10), 'is-danger': errors.has($t('texts.smsCode')) }">
                    {{ remainingtime > 0 ? smsCodeTime : 'Tekrar Gönder' }}
                  </a>
                </p>
              </div>
              <span class="help is-danger">{{ errors.first($t('texts.smsCode')) }}</span>
            </div>
            <template v-if='recaptchaSiteKey'>
              <vue-recaptcha ref="invisibleRecaptcha" @verify="onVerify" @expired="onExpired" size="invisible"
                :loadRecaptchaScript="true" :sitekey="recaptchaSiteKey" :language="captchaLanguage()" />
            </template>
            <!-- <ProposalButtons :prev="false" nextText="Giriş Yap" :nesxtActive="true"/> -->
            <div class="columns login-button">
              <div class="column is-12">
                <button type="submit" class="button is-primary is-medium is-fullwidth">{{ $t('buttons.enter') }}</button>
              </div>
            </div>
          </div>
          <!-- <div v-on:click.stop="openCreatePasswordForm()" class="create-password button is-default is-large is-fullwidth">
            <span>Şifre oluştur</span>
          </div> -->
        </form>
        </div>
        <div class="qr-container" v-bind:class="{ 'isMobile': $isMobile }">
          <div class="qr-box">
            <qrcode class="qr" value="https://eurekosigorta.com.tr/app" :options="{ size: 150, padding:10 }"></qrcode>
            <p class="qr-text">Mobil Uygulamayı İndirin</p>
          </div>
        </div>
      </div>
    </div>
    <div class="sticky-container" v-bind:class="{ 'isDesktop': $isDesktop }">
      <img src="/static/img/qr-telefon.png" width="150">
      <span class="sticky-text">Tüm Sigortacılık İşlemleri Eureko Mobil ile Cebinde</span>
      <a href="https://eurekosigorta.com.tr/app" target="_blank">
        <button class="button downloadButton">İndir</button>
      </a>
    </div>
  </div>
</template>
<script>
import VueQrcode from '@xkeshi/vue-qrcode'
import service from '@/service'
import PopupHeader from '@/shared/widget/popupHeader'
import Description from '@/shared/widget/proposal/description'
const env = process.env.NODE_ENV
export default {
  name: 'Login',
  components: {
    PopupHeader,
    Description,
    'qrcode': VueQrcode
  },
  props: {
    headerTheme: {
      type: String,
      default: 'dark'
    }
  },
  metaInfo: {
    script: [
      { src: 'https://eureko.api.useinsider.com/ins.js?id=10003160', async: true, defer: true }
    ]
  },
  data () {
    return {
      customer: {
        tckn: '',
        vkn: '',
        phone: '',
        code: null,
        maskedPhone: '',
        isCustomer: true
      },
      openPhoneArea: false,
      checkPhoneStatus: false,
      smsCodeCountDate: null,
      remainingtime: 0,
      smsCodeTime: '',
      recaptchaSiteKey: '',
      Recaptcha: '',
      activeTabIndex: '0',
      environment: null
    }
  },
  mounted () {
    this.recaptchaSiteKey = this.getRecaptchaKey()
    this.removeCustomerInfo()
    this.environment = env
  },
  methods: {
    loginClose () {
      this.$emit('closePanel')
      // this.eventHub.eventHub.$emit('close-login-form', {})
    },
    submit: function (e) {
      var self = this
      e.preventDefault()
      this.$validator.validateAll().then(function (result) {
        if (result) {
          if (!self.openPhoneArea && !self.checkPhoneStatus) {
            self.getPhone()
          } else if (self.openPhoneArea && !self.checkPhoneStatus) {
            if (self.getMod() !== 'dev') {
              self.$refs.invisibleRecaptcha.execute()
            } else {
              self.checkPhone()
            }
          } else {
            self.checkSmsCode()
          }
        }
      })
    },
    getPhone: function () {
      var self = this
      var data = {
        identityNo: self.customer.tckn !== '' ? self.customer.tckn : self.customer.vkn,
        isAgency: self.activeTabIndex === '2'
      }
      service.access.getPhone(self, self.eventHub, true, data).then(function (resp) {
        self.openPhoneArea = true
        self.$refs.mobilePhone.focus()
        var getPhoneRes = resp.data
        if (getPhoneRes.ResultType === 0) {
          self.customer.isCustomer = true
          self.customer.maskedPhone = getPhoneRes.ReturnObject
        } else {
          self.customer.isCustomer = false
          self.customer.maskedPhone = ''
          self.openPhoneArea = false
          // self.eventHub.$emit('show-message', {
          //   title: 'İşlem Başarısız.',
          //   message: getPhoneRes.ErrorMessage,
          //   messageType: 'warning',
          //   returnHomeActive: false,
          //   closeTime: 0
          // })
        }
      })
    },
    checkPhone: function () {
      var self = this
      var data = {
        identityNo: self.customer.tckn !== '' ? self.customer.tckn : self.customer.vkn,
        phoneNumber: self.customer.phone,
        isAgency: self.activeTabIndex === '2',
        Recaptcha: self.Recaptcha
      }
      service.access.checkPhone(self, self.eventHub, true, data, true).then(function (resp) {
        if (resp.ok) {
          var checkPhoneRes = JSON.parse(resp.bodyText)
          if (checkPhoneRes.ResultType !== 0) {
            self.checkPhoneStatus = false
          } else {
            self.checkPhoneStatus = true
            // todo: bu alan süre backend e taşındığında silinecek
            var second = 0
            if (checkPhoneRes.ReturnObject) {
              second = parseInt(checkPhoneRes.ReturnObject || '60')
            }
            self.smsCodeCountDate = self.$moment().add('second', second)
            self.smsCodeTimer()
          }
        }
      })
    },
    checkSmsCode: function () {
      var self = this
      var data = {
        identityNo: self.customer.tckn !== '' ? self.customer.tckn : self.customer.vkn,
        smsCode: self.customer.code,
        phoneNumber: self.customer.phone,
        isAgency: self.activeTabIndex === '2'
      }
      service.access.checkSmsCode(self, self.eventHub, true, data, true).then(function (resp) {
        if (resp.ok) {
          var checkSmsCodeRes = JSON.parse(resp.bodyText)
          var returnObject = checkSmsCodeRes.ReturnObject
          if (checkSmsCodeRes.ResultType === 0 && ((returnObject.CustomerInfo.CustomerNo) && true)) {
            window.setCustomer(returnObject.CustomerInfo)
            window.setRefreshToken(returnObject.RefreshToken)
            window.setToken(returnObject.Token)

            // self.loginClose()

            setTimeout(function () {
              self.eventHub.$emit('login', {
                value: true
              })
            }, 500)
            self.$gtm.trackView('PostLoginPage', 'Showing')
            this.gtmEvent('Login', 'success', 'Logged-in: ' + returnObject.CustomerInfo.CustomerNo, 1, 'UserLogin')

            this.insiderUserObject(returnObject.CustomerInfo)

            window.dataLayer.push({
              'event': 'kullanici_id',
              'kullanici_id': returnObject.CustomerInfo.CustomerNo
            })
            if (self.activeTabIndex !== '2') {
              self.$router.push({ name: 'Personal' })
            } else {
              // TODO: Yetki sorgusunu at, window.setCustomerAuth fonksiyonu ile kayıt yap
                var req = {
                  IdentityNo: self.customer.tckn !== '' ? self.customer.tckn : self.customer.vkn
                }
                service.customer.getAgencyAuthorizations(self, self.eventHub, true, req).then(function (resp) {
                  if (resp.ok) {
                    var resBody = JSON.parse(resp.bodyText)
                    var returnObject = resBody.ReturnObject
                    window.setAgencyAuthorizations(returnObject)
                    setTimeout(() => {
                      self.eventHub.$emit('agencyAuthorizationsReady', {
                        value: true
                      })
                    }, 1000)
                    self.$router.push({ name: 'AgencyPersonal' })
                  }
                })
            }
          } else {
            // TODO: Hata mesajı ekrana gösterilecek şekilde düzenlenmeli ???
            // console.log('Kullanıcı bilgisine ulaşılamadı.')
          }
        }
      })
    },
    sendSmsCode: function () {
      if (this.remainingtime > 0) { return }
      if (this.getMod() !== 'dev') {
        this.resetRecaptcha()
        this.$refs.invisibleRecaptcha.execute()
      } else {
        this.checkPhone()
      }
    },
    smsCodeTimer: function () {
      var self = this
      if (this.smsCodeCountDate == null) {
        self.remainingtime = 0
      } else {
        self.remainingtime = Math.max(this.smsCodeCountDate.diff(this.$moment()), 0)
      }
      if (self.remainingtime > 0) {
        self.smsCodeTime = self.$moment.utc(self.remainingtime).format('mm:ss')
      } else {
        self.smsCodeCountDate = null
      }
      setTimeout(function () {
        if (self.remainingtime > 0) self.smsCodeTimer()
      }, 1000)
    },
    onVerify (response) {
      if (response) {
        this.Recaptcha = response
        this.checkPhone()
      }
    },
    onExpired: function () {
      this.$refs.invisibleRecaptcha.reset()
    },
    resetRecaptcha () {
      this.$refs.invisibleRecaptcha.reset() // Direct call reset method
    },
    tabCallback: function (index) {
      this.activeTabIndex = index
    },
    insiderUserObject: async function (UserObj) {
      window.insider_object = window.insider_object || {}
      window.insider_object.user = {
        'uuid': UserObj.CustomerNo,
        'birthday': this.convertToRFC3339(UserObj.BirthDate),
        'email': UserObj.Email,
        'phone_number': this.countryPhoneNumber(UserObj.MobilePhone)
      }
      if (typeof Insider === "object" && Insider !== null) { // eslint-disable-line
        await Insider.eventManager.dispatch('init-manager:re-initialize') // eslint-disable-line
      }
    },
    convertToRFC3339: function (dateStr) {
      return dateStr + '.000Z'
    },
    countryPhoneNumber: function (phoneNumber) {
      const cleanedNumber = phoneNumber.replace(/\s+/g, '')
      const formattedNumber = `+90${cleanedNumber}`
      return formattedNumber
    }
  },
  computed: {
    loginActive: function () {
      return this.postLogin
    },
    title: function () {
      return (this.$isMobile) ? 'İnternet Şube' : ''
    },
    placeholder: function () {
      return (this.hasPhoneNumber) ? '5 _ _   _ _ _   _ _   ' + this.customer.maskedPhone : '5 _ _   _ _ _   _ _   _ _'
    },
    hasPhoneNumber: function () {
      return (this.openPhoneArea && this.customer.maskedPhone.length > 0)
    },
    isProd: function () {
      return this.environment === 'production' && !window.location.href.toLowerCase().includes('prep')
    }
  },
  watch: {
    'customer.tckn': function (value) {
      var self = this
      if (value.length === 11) {
        this.$validator.validateAll().then(function (result) {
          if (result) {
            self.getPhone()
          }
        })
      } else {
        self.openPhoneArea = false
      }
    },
    'customer.vkn': function (value) {
      var self = this
      if (value.length === 9 || value.length === 10) {
        this.$validator.validateAll().then(function (result) {
          if (result) {
            self.getPhone()
          }
        })
      } else {
        self.openPhoneArea = false
      }
    }
  }
}
</script>
<style scoped>
.login {
  height: 100%;
}

.login.isDesktop {
  width: 603px;
  height: 500px;
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  /*box-shadow: 0 20px 30px 0 rgba(20, 94, 151, 0.3);*/
}

.login.isMobile {
  height: calc(100% - 50px);
}

.login .info-text {
  background-color: var(--dark-bg5);
  height: calc(100% - 200px);
}

.login input.input {
  background-color: var(--light-bg1);
}
.login .info-text.isDesktop {
  background-color: var(--dark-bg5);
  border: 2px solid transparent;
  border-radius: 6px;
  height: auto;
}

.login .info-text .info-text-detail-paragraph {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--text-color1);
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.login .info-text .info-text-detail-paragraph.isDesktop {
  display: flex;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  color: var(--text-color1);
  margin: 0;
  position: relative;
  top: auto;
  transform: inherit;
}

.login .info-text .info-text-detail-paragraph .info-text-detail-header {
  padding: 20px 40px
}

.login.isMobile .info-text .info-text-detail-paragraph .info-text-detail-header {
  padding: 0px 15px;
}

.login .info-text .info-text-detail-paragraph .forgot-password {
  margin-bottom: 20px;
  text-align: center;
}

.login .info-text .info-text-detail-paragraph .forgot-password a {
  font-size: 0.938em;
  font-weight: 500;
  text-decoration: underline;
  line-height: 1.29;
  letter-spacing: -0.3px;
  color: var(--text-color1) !important;
}

.login .info-text .info-text-detail-paragraph .create-password {
  text-align: center;
}

.field.has-addons {
  display: flex;
  margin-bottom: 0;
}

.field.has-addons .control {
  width: 100%;
}

.field.has-addons .control:first-child input {
  border-right: 0;
  border-radius: 0;
  -webkit-border-top-left-radius: 4px;
  -webkit-border-bottom-left-radius: 4px;
  -moz-border-radius-topleft: 4px;
  -moz-border-radius-bottomleft: 4px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.field.has-addons .control:last-child {
  max-width: 110px;
}

.field.has-addons .control:last-child a.button {
  width: 100%;
  height: 48px;
  border-radius: 0;
  -webkit-border-top-right-radius: 4px;
  -webkit-border-bottom-right-radius: 4px;
  -moz-border-radius-topright: 4px;
  -moz-border-radius-bottomright: 4px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  font-size: 0.85em;
}

.field.has-addons .control:last-child a.button.is-danger {
  border-width: thin;
  background-color: #fff;
  color: #000;
  border-color: #e52226;
}

.field.has-addons .control:last-child a.button.disabled {
  cursor: default;
}

.field.has-addons .control:last-child a.button.disabled.last10 {
  color: #e52226;
}

.field.has-addons .control:last-child a.button.disabled:hover {
  border-color: #dbdbdb;
}

.field.has-addons .control:last-child a.button.disabled:active {
  box-shadow: 0;
}

.login .form-control-elements {
  padding: 20px 40px 0px 40px;
}

.login .login-selection {
  padding: 0 40px 0px 40px;
}

.login .login-selection.mobile .blu-radio {
  margin-bottom: 12px;
  margin-top: 5px;
}
.login .login-selection .blu-radio {
  display: flex;
  align-items: center;
}

.login .login-selection .blu-radio.on:after {
  top: 0px;
}

.login .form-control-elements.verification-elements {
  padding-top: 0;
  padding-bottom: 20px;
}

.login.isMobile .form-control-elements.verification-elements {
  padding-top: 0 !important;
}

.login.isMobile .form-control-elements {
  padding: 15px;
  padding-bottom: 0;
}

.login .login-button {
  flex-direction: row-reverse;
  margin-top: 20px;
}
.form-container.isDesktop {
  min-width: 400px;
}
.qr-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.qr-box {
  background: #0C5AA7;
  text-align: center;
  padding: 10px;
  border-radius: 7px;
}
.qr-box canvas {
  border-radius: 4px;
}
.qr-text {
  color: #fff;
  font-family: 'HostGrotesk ExtraBold', sans-serif;
  font-size: 12px;
  padding-top: 10px;
  padding-bottom: 5px;
}
.qr-container.isMobile {
  display: none;
}
.sticky-container {
  display: flex;
  align-items: center;
  position: sticky;
  bottom: 0px;
  width: 100%;
  background-color: #fff;
  color: #000;
  text-align: center;
  padding: 10px 10px 0 0;

}
.sticky-container.isDesktop {
  display: none;
}
.sticky-text {
  padding: 0 10px;
  font-family: 'HostGrotesk ExtraBold', sans-serif;
  font-size: 14px;
}
.downloadButton {
  width: 76px;
  background-color: #6EAB15;
  color: #fff;
}
</style>

<style>
.login .tab-list {
  display: inline;
  margin: 0 auto;
  width: 100%;
  text-align: center;
}

.login .tabs:not(:last-child) {
  margin-bottom: 10px;
}

.login .tabs ul {
  border-bottom: none;
  background-color: var(--light-bg1);
  
  padding: 10px 15px;
  border-radius: 25px;
}

.login.isDesktop .tabs ul {
  width: 80%;
}

.login.isMobile .tabs ul {
  width: 90%;
}

.login .tabs .tab-list li {
  line-height: 30px !important;
  display: inline-block !important;
}

.login .tabs li.is-active a {
  position: relative !important;
  font-size: 13px !important;
  letter-spacing: -0.380953px !important;
  color: var(--text-color4) !important;
  border-radius: 25px;
  background-color: var(--text-color7);
  border-color: var(--text-color7);    
  z-index: 1;
  padding: 8px 40px;
}

.login .tab-list li.is-active {
  position: relative;
}

.login .tabs li a {
  font-size: 13px !important;
  letter-spacing: -0.380953px !important;
  border-bottom: none;
  padding: 8px 40px;
}

.login .tabs .tab-content {
  margin: 0 !important;
}

.login .form-header {
  padding: 22px !important;
  padding-bottom: 0px !important;
}

.login.isMobile .form-header {
  padding: 15px !important;
  border-bottom: 1px solid #D5DFE5 !important;
}

.login .desc-cover {
  margin-bottom: 0px !important;
}

.login .desc-cover .desc-title {
  font-family: 'HostGrotesk ExtraBold', sans-serif;
  font-weight: bold !important;
  font-size: 18px !important;
  margin-bottom: 5px !important;
}

.login .desc-cover .desc-title span {
  font-family: 'HostGrotesk ExtraBold', sans-serif;
}

.login .desc-cover .desc-text {
  font-size: 13px !important;
  line-height: 16px !important;
  color: var(--text-color5) !important;
}

.login .desc-cover .desc-text span {
  font-family: 'HostGrotesk ExtraBold', sans-serif;
}

.login.isMobile .tab-content {
  max-height: fit-content;
}

.login .button {
  border-radius: 5px;
}

</style>



// WEBPACK FOOTER //
// src/shared/widget/header/login.vue